module.exports = __webpack_public_path__ + "static/media/tScott.c7169f67.jpeg";